import formReducer from 'redux-form/lib/reducer'

export default formReducer
